import React,{ useEffect, useState, useCallback } from "react";
import {
  TUIKit,
  TUIConversationList,
  TUIChat,
  TUIChatHeader,
  TUIMessageList,
  TUIMessageInput,
  TUIProfile,
  TUIConversation,
  TUIManage,
} from "@tencentcloud/chat-uikit-react";
import TencentCloudChat, { ChatSDK, Message } from "@tencentcloud/chat";
import { TUIChatService, TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import { ROBOT_WELCOME_PAYLOAD, ROBOT_USERS } from "./common/constants";
import { JSONStringToParse } from './utils/index'
import { BotPrompt } from "./components/BotPrompt/BotPrompt";
import { BotRating } from "./components/BotRating/BotRating";
import { BotCard } from "./components/BotCard/BotCard";
import { BotStream } from "./components/BotStream/BotStream";
import TUIChatEmpty from './TUIChatEmpty';

import "@tencentcloud/chat-uikit-react/dist/cjs/index.css";
import "./style.scss";

interface ITasks {
  [key: string]: boolean;
}

  // 后台协定：
  // chatbotPlugin 为 1 : 机器人发送的消息
  // src: 区分消息类型: 2 | 流式输出、 7 | 激活欢迎卡片 、8 | 欢迎语 、 15 | 澄清消息/返回欢迎语卡片
  // 卡片消息：自定义消息：澄清消息（subtype: clarify_msg） && 欢迎卡片（subtype: welcome_msg）

const componentVisibleOptions = {
  isProfileShow: true,
  isSearchInputShow: false,
  isContainerShow: true,
};

// 输入框配置
const inputConfig = {
  pluginConfig: {
    isImagePicker: false,
    isVideoPicker: false,
    isFilePicker: false,
    isEmojiPicker: false
  },
};


export default function BotDemo(props: any) {
  const { handleTaskList, className } = props;
  const [chat, setChat] = useState<ChatSDK>();
  const [activeConversationIDList, setActiveConversationIDList] = useState<Array<string>>([]);
  const [isCompleteWelcome, setIsCompleteWelcome] = useState<boolean>(false);
  const [currentLanguage, setCurrentLanguage] = useState<string>('en-US');

  const activateRobot = useCallback((chat:ChatSDK) => {
    setIsCompleteWelcome(true);
    ROBOT_USERS.map((userInfo: any) => {
      TUIChatService.sendCustomMessage({
        to: userInfo.userID,
        conversationType: TencentCloudChat.TYPES.CONV_C2C,
        payload: ROBOT_WELCOME_PAYLOAD,
      });
      return userInfo;
    })
  }, [])

  useEffect(() => {
    TUIStore.watch(StoreName.APP, {
      tasks: (tasks: ITasks) => {
        if(tasks.sendMessage) {
          handleTaskList("send");
        };
      },
    });
  },[]);

  useEffect(() => {
    if (!props?.chat) {
      return;
    }
    setChat(props.chat);
    if (!isCompleteWelcome) {
      activateRobot(props?.chat);
    }
  }, [props]);

  const handleSendMessage = async (message: Message) => {
    // 用户进入机器人会话页面后，可发送如下自定义消息，以自动触发机器人欢迎语。chatbotPlugin: 1, src: 7
    const botData = JSONStringToParse(message.payload?.data);
    if (message.type === TencentCloudChat.TYPES.MSG_CUSTOM && botData.src === 7) {
      return chat?.sendMessage(message);
    }
    return chat?.sendMessage(message);
  };

  // 过滤消息
  const filterMessage = (messageList: any) => {
    // 如果 messageList 不存在，则直接返回 messageList
    if (!messageList) return messageList;
    // 使用 filter 方法过滤掉不符合条件的消息
    return messageList.filter((item: any) => {
      // 如果 item 的类型是 TencentCloudChat.TYPES.MSG_CUSTOM 且有 payload.data，则检查 src 是否不等于 7 和 8
      if (item.type === TencentCloudChat.TYPES.MSG_CUSTOM && item.payload.data) {
        const data = JSONStringToParse(item.payload.data);
        return data.src !== 7 && data.src !== 8;
      }
      // 如果 item 的类型不是 TencentCloudChat.TYPES.MSG_CUSTOM 或没有 payload.data，则保留 item
      return true;
    });
  };

  // 过滤机器人会话列表
  const filterBotConversation = (conversationList: Array<any>) => {
    return conversationList.filter((item) => {
      return !!ROBOT_USERS.find((userInfo: any) => {
        return `C2C${userInfo.userID}` === item.conversationID;
      })
    });
  };

  // bot 消息配置
  const messageConfig = ({ message }: any) => {
    if (message.flow === 'out' || isCardMessage(message)) return
    return (
      <>
        <BotRating handleTaskList={handleTaskList} message={message} modifyMessage={modifyMessage}></BotRating>
      </>
    );
  };

  const MessageContext = (value: any) => {
    return (
      <>
        <BotCard data={value}></BotCard>
      </>
    );
  };

  const MessageTextPluginContext = (props: any) => {
    return (
      <>
        <BotStream message={props.data}></BotStream>
      </>
    );
  };

  const modifyMessage = async (message: any) => {
    await chat?.modifyMessage(message);
  }

  const isCardMessage = (message: any) => {
    if (message.type !== TencentCloudChat.TYPES.MSG_CUSTOM) return false;
    const { chatbotPlugin, src, subtype } = JSONStringToParse(message.payload.data)
    return chatbotPlugin === 1 && src === 15 && (subtype === "welcome_msg" || subtype === "clarify_msg")
  }

  const setActiveConversationID = (conversationID: string) => {
    if (!activeConversationIDList.includes(conversationID)) {
      setActiveConversationIDList(activeConversationIDList.concat([conversationID]));
    }
  }

  return (
    <div className={`bot-chat ${className}`}>
     <TUIKit chat={chat} language={currentLanguage}>
       <div className="bot-chat-left-container">
        <TUIProfile className="bot-chat-profile" />
        <TUIConversation>
          <TUIConversationList
            componentVisibleOptions={componentVisibleOptions}
            filterConversation={filterBotConversation}
          />
        </TUIConversation>
        </div>
        <>
        <TUIChat
          MessageTextPlugins={MessageTextPluginContext}
          MessageCustomPlugins={MessageContext}
          MessagePlugins={messageConfig as any}
          TUIMessageInputConfig={inputConfig}
          filterMessage={filterMessage}
          sendMessage={handleSendMessage}
          EmptyPlaceholder={<TUIChatEmpty />}
        >
          <TUIChatHeader />
          <TUIMessageList />
          <BotPrompt
            activeConversationIDList={activeConversationIDList}
            setActiveConversationID={setActiveConversationID} />
          <TUIMessageInput />
        </TUIChat>
        <TUIManage></TUIManage>
        </>
      </TUIKit>
    </div>
  );
}
